export const LOGO_URL = "https://customer-assets.emergentagent.com/job_dc8322a1-d903-4660-81a7-be758d0d5bcd/artifacts/hhjewawk_PNG.OOE.PNG";

export const IMG = {
  romanesco_carrots: "https://customer-assets.emergentagent.com/job_dc8322a1-d903-4660-81a7-be758d0d5bcd/artifacts/5ty8n5do_20251223_150139.jpg",
  herbs: "https://customer-assets.emergentagent.com/job_dc8322a1-d903-4660-81a7-be758d0d5bcd/artifacts/mg5nw4e2_20251223_150440.jpg",
  rainbow_carrots_wide: "https://customer-assets.emergentagent.com/job_dc8322a1-d903-4660-81a7-be758d0d5bcd/artifacts/v3pgf8p2_IMG_20260125_163437_497.webp",
  mirepoix: "https://customer-assets.emergentagent.com/job_dc8322a1-d903-4660-81a7-be758d0d5bcd/artifacts/oghapbf9_20260127_140424.jpg",
  plated_fish: "https://images.unsplash.com/photo-1676471926534-d5c9771909fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwcGxhdGVkJTIwZm9vZCUyMGZpbmUlMjBkaW5pbmd8ZW58MHx8fHwxNzc5MTU1MjU5fDA&ixlib=rb-4.1.0&q=85",
  meal_prep_branded: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/q3yvbzlz_20260520_123344.jpg",
  meal_prep_plated: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/b5nj972w_20260520_123459.jpg",
  stock_pot: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/nr9l6ess_20260525_182702.jpg",
  artichokes: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/sc9msujy_image.png",
  dough_ball: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/h7ehyew9_IMG-20260508-WA0006.jpeg",
  gourmet_plate: "https://images.pexels.com/photos/15671411/pexels-photo-15671411.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chef_sauce: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwcGxhdGVkJTIwZm9vZCUyMGZpbmUlMjBkaW5pbmd8ZW58MHx8fHwxNzc5MTU1MjU5fDA&ixlib=rb-4.1.0&q=85",
  chef_cooking: "https://images.pexels.com/photos/4590943/pexels-photo-4590943.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  table_setting: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXRlcmluZyUyMGV2ZW50JTIwdGFibGUlMjBzZXR0aW5nfGVufDB8fHx8MTc3OTE1NTI2MHww&ixlib=rb-4.1.0&q=85",
};

export const CONTACT = {
  email: "andy@outofeden.ca",
  phone: "647-607-3745",
  instagram: "@outofedenca",
  instagramUrl: "https://instagram.com/outofedenca",
  website: "outofeden.ca",
  location: "London, Ontario",
};

export const MENU_SECTIONS = [
  {
    id: "canapes",
    title: "Canapés",
    blurb: "One-bite preludes, designed to set the tone for an exceptional evening.",
    items: [
      { name: "Tuna Crudo Tartlet", desc: "Sashimi-grade tuna, avocado crema, wasabi sesame crema, garlic chip & chive." },
      { name: "Lemon Garlic Shrimp Scampi", desc: "Butterflied large shrimp with fresh lemon, thyme, butter and dill." },
      { name: "Roasted Rack of Lamb Chops", desc: "Dijon and herb crusted, served with salsa verde." },
      { name: "Grilled AAA Beef Satay", desc: "Tender beef sirloin, marinated and lightly charred, served with our in-house horseradish aioli." },
      { name: "Lobster Brioche", desc: "Butter-poached Atlantic lobster, tarragon aioli, toasted brioche." },
    ],
  },
  {
    id: "salads",
    title: "Salads",
    blurb: "Garden-forward compositions celebrating texture, acidity, and seasonal restraint.",
    items: [
      { name: "Heritage Tomato & Burrata", desc: "Vine-ripened heirlooms, fresh burrata, basil oil, aged sherry vinegar, sea salt." },
      { name: "Tokyo Slaw", desc: "Red and napa cabbage, yu choy, carrot, edamame, seaweed, candied sesame, scallion — miso yuzu vinaigrette." },
      { name: "Broccoli, Blueberry & Walnut Salad", desc: "Broccoli, blueberries, walnuts, spinach, pumpkin seeds — sweet Vidalia dressing." },
      { name: "Beet, Citrus & Fennel Salad", desc: "Cara Cara orange, grapefruit, roasted and pickled beets, shaved fennel, chilis, Cerignola olives, dill, basil, mint — citrus vinaigrette." },
      { name: "Classic Greek Salad", desc: "Marinated tomato and cucumber, peppers, red onion, oregano, sheep's milk feta, kalamata olives, basil, EVOO, sea salt." },
    ],
  },
  {
    id: "chicken",
    title: "Chicken",
    blurb: "Fresh local pasture-raised chickens.",
    items: [
      { name: "Ontario Lemon-Thyme Chicken Breast", desc: "Marinated and pan-seared to golden perfection. Served with sauce velouté." },
      { name: "Coq au Vin Modern", desc: "Slow-braised pasture chicken in Pinot Noir, pearl onions, lardons, cremini mushrooms." },
      { name: "Traditional Jerk Chicken Thighs", desc: "In-house jerk marinade with allspice, black pepper, nutmeg, scallion, scotch bonnet, thyme. Char-grilled and slow-cooked." },
      { name: "BBQ Chicken Thighs", desc: "Marinated in our Texas spice rub. Char-grilled and slow-cooked with our in-house sweet and tangy BBQ sauce." },
      { name: "Kerala Chicken Curry", desc: "Fresh aromatic spices — mustard seed, cumin, Kashmiri chili, fennel, curry leaf — scent this coconut-backed, flavourful curry." },
    ],
  },
  {
    id: "pork",
    title: "Pork",
    blurb: "Ontario-raised pork.",
    items: [
      { name: "Porchetta Roast Pork Shoulder", desc: "Marinated in thyme, rosemary, parsley, lemon zest, fennel, black peppercorns and Calabrian chilis. 24-hour sous-vide and pan-seared to juicy, tender goodness." },
      { name: "Char Siu Roast Pork", desc: "Marinated in honey, tamari, five-spice, garlic, fermented red bean curd and hoisin sauce." },
      { name: "Pork Belly à la French Laundry", desc: "Brined, confit, pressed and pan-fried. Pear & green grape agrodolce or Hawaiian poke sauce." },
      { name: "Grilled Pork Sausage", desc: "Garlic or Italian sausage made from pasture-raised, GMO-free pigs. Pickled veg and caramelized onions." },
      { name: "BBQ Baby Back Ribs", desc: "Marinated in our spice rub overnight, slow-cooked and slathered with our in-house BBQ sauce." },
    ],
  },
  {
    id: "beef",
    title: "Beef",
    blurb: "A nutritional powerhouse — providing highly bioavailable iron, complete high-quality protein and essential B vitamins. Supports muscle maintenance, energy metabolism and cognitive function.",
    items: [
      { name: "Beef Ribs", desc: "Low and slow, fall-off-the-bone beef ribs served with demi and horseradish." },
      { name: "Korean BBQ Beef", desc: "Tender thin cuts of marinated and grilled chuck. Scallion and pickled chili garnish." },
      { name: "Bœuf Bourguignon", desc: "Iconic French stew featuring tender chunks of beef braised in red wine, beef stock and garlic. Elevated by a classic garnish of lardons, pearl onions and cremini mushrooms." },
      { name: "Thai Basil Beef", desc: "Fresh ground Canadian beef seasoned with ginger, garlic, scallion, basil and our in-house tamari & Red Boat 40°N fish sauce glaze." },
    ],
  },
  {
    id: "seafood",
    title: "Seafood",
    blurb: "Delivering high-quality, lean protein, vital vitamins like D and B12, and essential minerals. Its biggest superpower is being rich in Omega-3 fatty acids, which significantly boost brain and heart health.",
    items: [
      { name: "Pan-Seared Halibut", desc: "Crisp-skin halibut, tarragon citrus beurre blanc, charred lemon." },
      { name: "Kerala Shrimp Curry", desc: "Kerala spices, coconut, curry leaf, ginger, butterflied shrimp." },
      { name: "Branzino Fillet", desc: "Herbs, citrus and a delicate beurre blanc." },
      { name: "Paddy's Pan-Fried East Coast Haddock", desc: "Lightly floured and dipped in free-run eggs, shallow-pan-fried to perfection. Served with lemon." },
      { name: "Chilean Antibiotic-Free Coho Salmon", desc: "Highly prized for its vibrant red-orange flesh, firm texture and rich, milder flavour. Pan-seared with your choice of teriyaki glaze or piccata sauce." },
    ],
  },
  {
    id: "sides",
    title: "Sides",
    blurb: "Studied accompaniments — never an afterthought.",
    items: [
      { name: "Pommes Purée", desc: "Classic French potato purée, cultured butter, a hint of sea salt." },
      { name: "Glazed Heirloom Carrots & Sweet Summer Peas", desc: "Rainbow carrots and sweet summer peas, honey-thyme glaze, toasted hazelnut, brown butter." },
      { name: "London Asparagus", desc: "Cured egg yolk, raw wildflower honey, EVOO, sea salt and fresh-cracked black peppercorns." },
      { name: "Bella Italia", desc: "Caramelized fennel, rapini, fresh artichokes, roasted peppers, olives, zucchini." },
      { name: "Cider Roasted London Cabbage", desc: "Apple cider gastrique, butter and caraway." },
      { name: "Pan-Roasted Young Yukon Gold Potatoes", desc: "Lots of butter, thyme, rosemary, garlic and sea salt." },
    ],
  },
  {
    id: "patisserie",
    title: "Pâtisserie",
    blurb: "Sweet conclusions crafted with patience and precision.",
    items: [
      { name: "Tarte au Chocolat", desc: "Callebaut milk chocolate ganache, salted caramel." },
      { name: "Chocolate Mousse", desc: "Light, airy, intense chocolate. Macerated cherries." },
      { name: "Crème Brûlée", desc: "Tahitian vanilla custard, hard-cracked sugar, shortbread." },
      { name: "Lemon Curd Tart", desc: "Fresh-squeezed lemon juice and zest, honey, free-run egg yolks. Short-crust buttery pastry." },
      { name: "French Frangipane Fruit Tart", desc: "House-made frangipane and short-crust pastry. Your choice of rhubarb, Anjou pear, or plum." },
    ],
  },
];
